export function getCalendar() {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/olympic-json/api_calendar', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        })
            .then(res => res.json(res))
            .then(json => resolve(json))
            .catch(err => reject(err));
    });
}


export function getCalendarOrder(ids) {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/olympic-json/api_calendar/order', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                id: Object.assign({}, ids)
            })
        })
            .then(res => res.json(res))
            .then(json => resolve(json))
            .catch(err => reject(err));
    });
}

export function getCalendarLives() {
    return new Promise((resolve, reject) => {
        fetch('https://russian.rt.com/listing/type.Article.tag.live-update.tag.olimpiiskie-igry-2018-v-phyonchhane/prepare/json/100/0', {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json)
        ).catch(err => reject(err));
    });
}



// WEBPACK FOOTER //
// ./src/api/calendar.js